import React , {useEffect, useState} from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

// @material-ui/icons
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";

import { Link, Redirect, useParams } from "react-router-dom";

import axios from 'axios'

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

const useStyles = makeStyles(styles);

export default function NewUser() {
    
    const {id} = useParams();


    const [section_name, setsection_name] = React.useState("");
    const [section_nameState, setsection_nameState] = React.useState("");
    const [sections, setsections] = useState([]);
    const [force_update, setforce_update] = useState(false);    

    const [redirctTo, setRedirctTo] = useState(false);    
    const [redirctTo_new_user, setRedirctTo_new_user] = useState(false);
    const [token_logged, settoken_logged] = React.useState("");
    const [tc, setTC] = React.useState(false);
    const [Errmessage, setErrmessage] = React.useState("");
    const [new_id, setnew_id] = React.useState("");

    const verifyLength = (value, length) => {
        if (value.length >= length) {
            return true;
        }
        return false;
    };


    
  
  React.useEffect(() => {

      document.getElementById("test_id").innerHTML = "New Section";

      const local_login = localStorage.getItem('local_login')
      let token = "";
      if(local_login){
        try {
        const getToken = async () => {
          const res = await axios.post('/user/refresh_token', null)
          
          token = res.data.access_token;

          settoken_logged(token);

          const res2 = await axios.get('/user/infor', {
            headers: {Authorization: token}
          })     
          console.log( res2.data );

          
          
        }
        getToken()
          } catch (err) {
            setRedirctTo(true);
        }
      }else{
        setRedirctTo(true)
      }

        let section_array = [];
        let section = {};
        let reference_item = {};    
        reference_item.comments = [];   
        reference_item.recommendations = [];    
        reference_item.method = "1";
        let code_references = [];
        code_references.push(reference_item);
        section.code_references =  code_references;
        section.informations = [];  
        section.section_name_err = "";  
        section_array.push(section);

        setsections(section_array);

        
    
  }, [  ]);
  

  const registerClick = async e => {
    let section_send = [];
    let sections_array = sections;   
    let sections_send = sections;  
    let valid = 1;
    console.log(sections);
    for (let index = 0; index < sections.length; index++) {
        let section_name = document.getElementById('section_name_' + index ); 
        if(section_name.value === ""){
            valid = 0;
            sections_array[index].section_name_err = "error";
        }else{
            sections_array[index].section_name_err = "success";
            delete sections_send[index].section_name_err;
            sections_send[index].section_name = section_name.value;
        }

        for (let index2 = 0; index2 < sections[index].code_references.length; index2++) {
            let code_reference = document.getElementById('reference_' + index + "/" + index2 ); 
            if(code_reference.value === ""){
                valid = 0;
                sections_array[index].code_references[index2].reference_err = "error";
            }else{
                sections_array[index].code_references[index2].reference_err = "success";
                delete sections_send[index].code_references[index2].reference_err;
                sections_send[index].code_references[index2].reference = code_reference.value;
            }

            let code_description = document.getElementById('description_' + index + "/" + index2 ); 
            if(code_description.value === ""){
                valid = 0;
                sections_array[index].code_references[index2].description_err = "error";
            }else{
                sections_array[index].code_references[index2].description_err = "success";
                delete sections_send[index].code_references[index2].description_err;
                sections_send[index].code_references[index2].description = code_description.value;
            }

            if(sections_array[index].code_references[index2].method === "2"){
                let material_cost = document.getElementById('material_cost_' + index + "/" + index2 ); 
                if(material_cost.value != ""){
                    sections_send[index].code_references[index2].material_cost = material_cost.value;
                }
                let labor_cost = document.getElementById('labor_cost_' + index + "/" + index2 ); 
                if(labor_cost.value != ""){
                    sections_send[index].code_references[index2].labor_cost = labor_cost.value;
                }
            }

            

        }
    }
    
    if(valid === 1 && new_id == ""  ){
        let principal_section = sections_send[0].section_name;
        const res = await axios.post('/codeset/register_sections', {
            sections : sections_send, codeset_id : id, principal_section: principal_section
        })    
        console.log(res);
        setRedirctTo_new_user(true);
    }

    if(valid === 1 && new_id != ""  ){
        console.log(new_id);
        let principal_section = sections_send[0].section_name;
        const res2 = await axios.post('/codeset/update_sections', {
            sections : sections_send, section_id : new_id, principal_section: principal_section
        })     

        setRedirctTo_new_user(true);
    }
    

    setsections(sections_array);
    setforce_update(force_update => force_update + 1);

  };

  const test_blur = async e => {
    let section_send = [];
    let sections_array = sections;   
    let sections_send = sections;  
    let valid = 1;
    for (let index = 0; index < sections.length; index++) {
        let section_name = document.getElementById('section_name_' + index ); 
        if(section_name.value === ""){
            valid = 0;
            //sections_array[index].section_name_err = "error";
        }else{
            //sections_array[index].section_name_err = "success";
            //delete sections_send[index].section_name_err;
            sections_send[index].section_name = section_name.value;
        }

        for (let index2 = 0; index2 < sections[index].code_references.length; index2++) {
            let code_reference = document.getElementById('reference_' + index + "/" + index2 ); 
            if(code_reference.value === ""){
                valid = 0;
                //sections_array[index].code_references[index2].reference_err = "error";
            }else{
                //sections_array[index].code_references[index2].reference_err = "success";
                //delete sections_send[index].code_references[index2].reference_err;
                sections_send[index].code_references[index2].reference = code_reference.value;
            }

            let code_description = document.getElementById('description_' + index + "/" + index2 ); 
            if(code_description.value === ""){
                valid = 0;
                //sections_array[index].code_references[index2].description_err = "error";
            }else{
                //[index].code_references[index2].description_err = "success";
                // sections_send[index].code_references[index2].description_err;
                sections_send[index].code_references[index2].description = code_description.value;
            }

            if(sections_array[index].code_references[index2].method === "2"){
                let material_cost = document.getElementById('material_cost_' + index + "/" + index2 ); 
                if(material_cost.value != ""){
                    sections_send[index].code_references[index2].material_cost = material_cost.value;
                }
                let labor_cost = document.getElementById('labor_cost_' + index + "/" + index2 ); 
                if(labor_cost.value != ""){
                    sections_send[index].code_references[index2].labor_cost = labor_cost.value;
                }
            }

            

        }
    }
    

    if(valid === 1 && new_id == ""  ){
        let principal_section = sections_send[0].section_name;
        const res = await axios.post('/codeset/register_sections', {
            sections : sections_send, codeset_id : id, principal_section: principal_section
        })    
        console.log(res);
        setnew_id(res.data.response)
    }

    if(valid === 1 && new_id != ""  ){
        console.log(new_id);
        let principal_section = sections_send[0].section_name;
        const res2 = await axios.post('/codeset/update_sections', {
            sections : sections_send, section_id : new_id, principal_section: principal_section
        })     
    }
    


  };

    const add_code_refenece = (key_section) => {
        let sections_array = sections;
        let reference_item = {}; 
        reference_item.comments = []; 
        reference_item.recommendations = [];    
        reference_item.method = "1";
        let code_references = [];
        sections_array[key_section].code_references.push(reference_item);    
        setsections(sections_array);
        setforce_update(force_update => force_update + 1);
    };

    const add_sub_section = async e => {
        let sections_array = sections;
        let section = {};
        let reference_item = {};
        reference_item.code = "";   
        reference_item.comments = []; 
        reference_item.recommendations = [];    
        reference_item.method = "1";
        let code_references = [];
        code_references.push(reference_item);            
        section.code_references =  code_references;
        sections_array.push(section);   
        section.informations = []; 
        setsections(sections_array);
        setforce_update(force_update => force_update + 1);
    };

    const add_comment = (key,key_section) => {
        let sections_array = sections;
        let comment = document.getElementById('enter_comment_' + key_section + "/" + key); 
        if(comment.value != ""){
            sections_array[key_section].code_references[key].comments.push(comment.value);
            setsections(sections_array);
            setforce_update(force_update => force_update + 1);
            document.getElementById('enter_comment_' + key_section + "/" + key).value = "";    
        }else{
            setErrmessage("Comment Error");
            showNotification(true);
        }

        test_blur()
        
    };

    const add_recommendation = (key,key_section) => {
        let sections_array = sections;
        let recommendation = document.getElementById('enter_recommendation_' + key_section +"/"+ key); 
        if(recommendation.value != ""){
            sections_array[key_section].code_references[key].recommendations.push(recommendation.value);
            setsections(sections_array);
            setforce_update(force_update => force_update + 1);
            document.getElementById('enter_recommendation_' + key_section +"/"+ key).value = "";
        }else{
            setErrmessage("Recommendation Error");
            showNotification(true);
        }

        test_blur()
    };

    const delete_comment = (key,key_section,key_comment) => {
        let sections_array = sections;
        //delete sections_array[key_section].code_references[key].comments[key_comment];
        sections_array[key_section].code_references[key].comments.splice(key_comment,1);
        setsections(sections_array);
        setforce_update(force_update => force_update + 1);

        test_blur()
    };

    const delete_recommendation = (key,key_section,key_recommendation) => {
        let sections_array = sections;
        //delete sections_array[key_section].code_references[key].recommendations[key_recommendation];
        sections_array[key_section].code_references[key].recommendations.splice(key_recommendation,1);
        setsections(sections_array);
        setforce_update(force_update => force_update + 1);

        test_blur()
    };

    const handleChangeMethod = (key,key_section,event) => {        
        let sections_array = sections;
        sections_array[key_section].code_references[key].method = event.target.value;
        setsections(sections_array);
        setforce_update(force_update => force_update + 1);
        
    };

    const add_information = (key_section) => {
        let sections_array = sections;
        let information = document.getElementById('enter_information_' + key_section); 
        if(information.value != ""){
            sections_array[key_section].informations.push(information.value);
            setsections(sections_array);
            setforce_update(force_update => force_update + 1);
            document.getElementById('enter_information_' + key_section).value = "";
        }else{
            setErrmessage("Information Error");
            showNotification(true);
        }
        
    };

    const delete_information = (key_section,key_recommendation) => {
        let sections_array = sections;
        //delete sections_array[key_section].informations[key_recommendation];
        sections_array[key_section].informations.splice(key_recommendation,1);
        setsections(sections_array);
        setforce_update(force_update => force_update + 1);
    };

    const delete_code_reference = (key_section,key) => {
        let sections_array = sections;
        //delete sections_array[key_section].code_references[key];
        sections_array[key_section].code_references.splice(key,1)
        setsections(sections_array);
        setforce_update(force_update => force_update + 1);
    };

    const delete_section = (key_section) => {
        let sections_array = sections;
        //delete sections_array[key_section];
        sections_array.splice(key_section,1);
        sections_array =  filter_array(sections_array);
        setsections(sections_array);
        setforce_update(force_update => force_update + 1);
    };

    

    
    const filter_array = (array) => {
        let filtered = array.filter(function (el) {
            return el != null;
        });
        return filtered;
    } 

    const open_details = (key) => {
        document.getElementById('details_' + key).style.display = 'block';
        document.getElementById('details_close_' + key).style.display = 'block';
        document.getElementById('details_open_' + key).style.display = 'none';  
      }
    
      const close_details = (key) => {
        document.getElementById('details_' + key).style.display = 'none';
        document.getElementById('details_close_' + key).style.display = 'none';
        document.getElementById('details_open_' + key).style.display = 'block';  
      }

  

  const classes = useStyles();

  if (redirctTo){
    return <Redirect to='/auth/login-page'  />
  }

  if (redirctTo_new_user){
    return <Redirect to={'/admin/sections/' + id }  />
  }


  const showNotification = place => {
    setTC(true);
    setTimeout(function() {
      setTC(false);
    }, 3000);
  };

    
  
  
  return (
    <div>

      <Snackbar
        place="tc"
        color="rose"
        icon={AddAlert}
        message={Errmessage}
        open={tc}
        closeNotification={() => setTC(false)}
        close
      />
      
      <GridContainer>
          
        <GridItem xs={12} sm={12} md={12}>
            <div className={classes.right}>
                <Link to={"/admin/sections/"+id}>
                  <Button color="rose" className={classes.right}>
                      Back to All Sections
                  </Button>
                </Link>
                <Button onClick={registerClick} color="rose" className={classes.right}>
                    Save Section
                </Button>
            </div>
          {sections.map((section,key_section) =>
          <Card>
            <CardBody>
                
                    {(key_section === 0 ) && (
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12} className={classes.center} >
                            
                                <h4>Register New Section</h4>
                        </GridItem>
                    </GridContainer>
                    )}
                    {(key_section > 0 ) && (
                        <GridContainer
                            justify="space-between"
                            alignItems="center"
                            direction="row"
                        >
                            <GridItem xs={12} sm={12} md={3}>
                            
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3} className={classes.center}>
                                <h4>Register New Sub Section</h4>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3} className={classes.right}>
                                <Button onClick={(e)=>delete_section(key_section)} color="danger" round className={classes.actionButton}>
                                    <Close></Close>
                                </Button>
                            </GridItem>
                        </GridContainer>
                    )}
                    <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                            success={section.section_name_err === "success"}
                            error={section.section_name_err === "error"}
                            labelText="Section Name"
                            id={"section_name_" + key_section }
                            formControlProps={{
                            fullWidth: true
                            }}
                            inputProps={{
                                onChange: event => {
                                    
                                },
                                onBlur: event => {
                                    test_blur();            
                                },
                            type: "text",
                            autoComplete: "off"
                            }}
                        />
                    </GridItem>
                    {section.code_references.map((code_reference,key) =>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader className={classes.cardHearder_gray} style={{ backgroundColor: "#4EBCFC" }} >  
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>                              
                                        Code References 
                                    </GridItem>
                                    {(key > 0 ) && (
                                        <GridItem xs={12} sm={12} md={6} className={classes.right}>   
                                            <Button onClick={(e)=>delete_code_reference(key_section,key)} color="danger" round className={classes.actionButton}>
                                                <Close></Close>
                                            </Button>
                                        </GridItem>
                                    )}
                                </GridContainer>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <CustomInput
                                            success={code_reference.reference_err === "success"}
                                            error={code_reference.reference_err === "error"}
                                            labelText="Code Reference"
                                            id={"reference_" + key_section + "/" + key }
                                            formControlProps={{
                                            fullWidth: true
                                            }}
                                            inputProps={{
                                                onChange: event => {
                                                    
                                                },
                                                onBlur: event => {
                                                    test_blur();            
                                                },
                                            type: "text",
                                            autoComplete: "off"
                                            }}
                                        />
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <CustomInput
                                            success={code_reference.description_err === "success"}
                                            error={code_reference.description_err === "error"}
                                            labelText="Code Description"
                                            id={"description_" + key_section + "/" + key }
                                            formControlProps={{
                                            fullWidth: true
                                            }}
                                            inputProps={{
                                                onChange: event => {
                                                    
                                                },
                                                onBlur: event => {
                                                    test_blur();            
                                                },
                                            type: "text",
                                            autoComplete: "off"
                                            }}
                                        />
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12} >   
                                        <Button id={"details_open_" + + key_section + "/" + key } onClick={(e)=>open_details(key_section + "/" + key)} color="success" round className={classes.actionButton} style={{padding: "5px 10px"}} >
                                            +
                                        </Button>
                                        <Button id={"details_close_" + + key_section + "/" + key } onClick={(e)=>close_details(key_section + "/" + key)} color="success" round className={classes.actionButton} style={{display: "none", padding: "5px 10px"}} >
                                            -
                                        </Button>
                                    </GridItem>
                                    <div id={"details_" + key_section + "/" + key } style={{display: "none", width: "100%"}} >
                                    <GridItem xs={12} sm={12} md={12}>
                                        <Card>
                                            <CardHeader className={classes.cardHearder_black}>Comment</CardHeader>
                                            <CardBody>
                                                <GridContainer>
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <Table>
                                                            <TableBody>
                                                                <TableRow >
                                                                    <TableCell className={classes.cell_large} >

                                                                    <CustomInput
                                                                        success={section_nameState === "success"}
                                                                        error={section_nameState === "error"}
                                                                        labelText="Enter Comment"
                                                                        id={"enter_comment_" + key_section + "/" + key}
                                                                        formControlProps={{
                                                                        fullWidth: true
                                                                        }}
                                                                        inputProps={{
                                                                            onChange: event => {
                                                                                
                                                                            },
                                                                            onBlur: event => {
                                                                                test_blur();            
                                                                            },
                                                                        type: "text",
                                                                        autoComplete: "off"
                                                                        }}
                                                                    />
                                                                    </TableCell>
                                                                    <TableCell >
                                                                        <Button onClick={(e)=>add_comment(key,key_section)} color="info" round className={classes.marginRight}>
                                                                            Add
                                                                        </Button>
                                                                    </TableCell>
                                                                </TableRow>
                                                                {code_reference.comments.map((comment,key_comment) =>
                                                                    <TableRow >
                                                                        <TableCell className={classes.cell_large} >

                                                                            <span>{comment} </span>
                                                                        </TableCell>
                                                                        <TableCell >
                                                                            <Button onClick={(e)=>delete_comment(key,key_section,key_comment)} color="danger" round className={classes.actionButton}>
                                                                                <Close></Close>
                                                                            </Button>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )}

                                                            </TableBody>
                                                        </Table>
                                                    </GridItem>
                                                </GridContainer>
                                            </CardBody>
                                        </Card>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <Card>
                                            <CardHeader className={classes.cardHearder_black} >Recommendations</CardHeader>
                                            <CardBody>
                                                <GridContainer>
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <Table>
                                                            <TableBody>
                                                                <TableRow >
                                                                    <TableCell className={classes.cell_large} >

                                                                    <CustomInput
                                                                        success={section_nameState === "success"}
                                                                        error={section_nameState === "error"}
                                                                        labelText="Enter Recommendation"
                                                                        id={"enter_recommendation_" + key_section + "/" + key}
                                                                        formControlProps={{
                                                                        fullWidth: true
                                                                        }}
                                                                        inputProps={{
                                                                            onChange: event => {
                                                                                
                                                                            },
                                                                            onBlur: event => {
                                                                                test_blur();            
                                                                            },
                                                                        type: "text",
                                                                        autoComplete: "off"
                                                                        }}
                                                                    />
                                                                    </TableCell>
                                                                    <TableCell >
                                                                        <Button onClick={(e)=>add_recommendation(key,key_section)} color="info" round className={classes.marginRight}>
                                                                            Add
                                                                        </Button>
                                                                    </TableCell>
                                                                </TableRow>
                                                                {code_reference.recommendations.map((recommendation,key_recommendation) =>
                                                                    <TableRow >
                                                                        <TableCell className={classes.cell_large} >

                                                                            <span>{recommendation} </span>
                                                                        </TableCell>
                                                                        <TableCell >
                                                                            <Button onClick={(e)=>delete_recommendation(key,key_section,key_recommendation)} color="danger" round className={classes.actionButton}>
                                                                                <Close></Close>
                                                                            </Button>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )}

                                                            </TableBody>
                                                        </Table>
                                                    </GridItem>
                                                </GridContainer>
                                            </CardBody>
                                        </Card>
                                    </GridItem>
                                    
                                    <GridItem xs={12} sm={12} md={12}>
                                    <Card>
                                    <CardHeader className={classes.cardHearder_black} >Method Of Estimating</CardHeader>
                                    <CardBody>
                                        <div
                                            className={
                                            classes.checkboxAndRadio +
                                            " " +
                                            classes.checkboxAndRadioHorizontal
                                            }
                                        >
                                            <FormControlLabel
                                            control={
                                                <Radio
                                                checked={code_reference.method === "1"}
                                                onChange={(e)=>handleChangeMethod(key,key_section,e)}
                                                value="1"
                                                name="radio[]"
                                                aria-label="A"
                                                icon={
                                                    <FiberManualRecord
                                                    className={classes.radioUnchecked}
                                                    />
                                                }
                                                checkedIcon={
                                                    <FiberManualRecord
                                                    className={classes.radioChecked}
                                                    />
                                                }
                                                classes={{
                                                    checked: classes.radio,
                                                    root: classes.radioRoot
                                                }}
                                                />
                                            }
                                            classes={{
                                                label: classes.label,
                                                root: classes.labelRoot
                                            }}
                                            label="Sign Count"
                                            />
                                        </div>

                                        <div
                                            className={
                                            classes.checkboxAndRadio +
                                            " " +
                                            classes.checkboxAndRadioHorizontal
                                            }
                                        >
                                            <FormControlLabel
                                            control={
                                                <Radio
                                                checked={code_reference.method === "2"}
                                                onChange={(e)=>handleChangeMethod(key,key_section,e)}
                                                value="2"
                                                name="radio[]"
                                                aria-label="A"
                                                icon={
                                                    <FiberManualRecord
                                                    className={classes.radioUnchecked}
                                                    />
                                                }
                                                checkedIcon={
                                                    <FiberManualRecord
                                                    className={classes.radioChecked}
                                                    />
                                                }
                                                classes={{
                                                    checked: classes.radio,
                                                    root: classes.radioRoot
                                                }}
                                                />
                                            }
                                            classes={{
                                                label: classes.label,
                                                root: classes.labelRoot
                                            }}
                                            label="Square Footage"
                                            />
                                        </div>

                                                                               
                                        
                                        {(code_reference.method === "2" ) && (
                                        
                                            <GridContainer>
                                                <GridItem xs={12} sm={12} md={2}>
                                                    Material Cost/Sq Ft
                                                    <CustomInput
                                                        id={"material_cost_" + key_section + "/" + key }
                                                        formControlProps={{
                                                        fullWidth: true
                                                        }}
                                                        inputProps={{
                                                        placeholder: "$0.00"
                                                        }}
                                                    />
                                                </GridItem>    
                                                <GridItem xs={12} sm={12} md={2}>
                                                    Labor Cost/Sq Ft
                                                    <CustomInput
                                                        id={"labor_cost_" + key_section + "/" + key }
                                                        formControlProps={{
                                                        fullWidth: true
                                                        }}
                                                        inputProps={{
                                                        placeholder: "$0.00"
                                                        }}
                                                    />
                                                </GridItem> 
                                            </GridContainer>
                                        
                                        )}    
                                        </CardBody>
                                        </Card>
                                        </GridItem>
                                        </div>   
                                        
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                    )}
                    <GridItem xs={12} sm={12} md={12}>
                        <Button onClick={(e)=>add_code_refenece(key_section)} color="info" round className={classes.marginRight}>
                            New Code Reference
                        </Button>
                    </GridItem>     
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader className={classes.cardHearder_yellow} >Section Information</CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <Table>
                                            <TableBody>
                                                <TableRow >
                                                    <TableCell className={classes.cell_large} >

                                                    <CustomInput
                                                        success={section_nameState === "success"}
                                                        error={section_nameState === "error"}
                                                        labelText="Enter Section Information"
                                                        id={"enter_information_" + key_section}
                                                        formControlProps={{
                                                        fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event => {
                                                                
                                                            },
                                                            onBlur: event => {
                                                                test_blur();            
                                                            },
                                                        type: "text",
                                                        autoComplete: "off"
                                                        }}
                                                    />
                                                    </TableCell>
                                                    <TableCell >
                                                        <Button onClick={(e)=>add_information(key_section)} color="info" round className={classes.marginRight}>
                                                            Add
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                                {section.informations.map((information,key_information) =>
                                                    <TableRow >
                                                        <TableCell className={classes.cell_large} >

                                                            <span>{information} </span>
                                                        </TableCell>
                                                        <TableCell >
                                                            <Button onClick={(e)=>delete_information(key_section,key_information)} color="danger" round className={classes.actionButton}>
                                                                <Close></Close>
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                )}

                                            </TableBody>
                                        </Table>
                                    </GridItem>
                                    
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>

            </CardBody>
          </Card>
          )}
          <div className={classes.right}>     
                <Link to={"/admin/sections/"+id}>
                  <Button color="rose" className={classes.right}>
                      Back to All Sections
                  </Button>
                </Link>
                <Button onClick={registerClick} color="rose" className={classes.right}>
                    Save Section
                </Button>
                <Button onClick={add_sub_section} color="info" className={classes.right}>
                    Add Sub Section
                </Button>
            </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}
